"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = void 0;
var history_1 = require("history");
var basename = process.env.PUBLIC_URL || '/';
exports.history = history_1.createBrowserHistory({
    basename: basename,
});
//# sourceMappingURL=BrowserHistory.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/BrowserHistory/BrowserHistory.js
// module id = 991
// module chunks = 8